<template>
  <div class="text-left pb-16">
    <transition name="slide">
      <ProductSlideover v-if="slide" :productData="slide" @close="slide = null" />
    </transition>
      <div class="sticky top-0 left-0 bg-primary-100 z-40">
        <div class="mx-auto px-4 py-7 sm:px-6 lg:px-8">
          <div class="max-w-7xl mx-auto flex justify-between flex-wrap">
          <img src="/logo2.png" class="block h-10 self-start">
          <a
            @click="checkout"
            :class="{'opacity-40': cart.length < 3 || cart.length > 5, 'pointer-events-none': cart.length < 3 || cart.length > 5}"
            class="cursor-pointer sm:mt-0 mt-4 flex text-lg self-start max-w-max pr-4 text-white pl-9 items-center w-full bg-orange hover:bg-orange-400 rounded-md py-2 font-semibold text-center"
          >
            <svg
              class="absolute -ml-7 mr-3 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
            <span v-if="cart.length < 3">wählen Sie mindestens 3 Produkte</span>
            <span v-else-if="cart.length > 5">wählen Sie höchstens 5 Produkte</span>
            <span v-else>Jetzt meine Box sichern</span>
            </a>
          </div>
        </div>
      </div>
    <div class="bg-primary-100">
      <div class="mx-auto px-4 pb-16 sm:px-6 lg:px-8">
        <div class="max-w-7xl mx-auto sm:flex sm:flex-col sm:align-center">
          
          <h1 class="text-5xl pt-8 font-extrabold text-gray-900">
            Für
            {{ answers.name && answers.name !== "" ? answers.name : "Dich" }}
          </h1>
          <p class="mt-5 text-xl text-gray-500">
            Hier sind unsere Empfehlungen für Deine erste Bestellung.
          </p>
          <p class="mt-0 text-xl text-gray-500">
            Sie basiert auf der Auswertung deiner Antworten.
          </p>
          <p class="mt-0 text-xl text-gray-500">
            Wählen Sie 3-5 Wirkstoffe.
          </p>
          <div
            class="relative self-start mt-6 bg-gray-100 rounded-lg p-0.5 flex sm:mt-8"
          >
            <button
              type="button"
              @click="vegan = true"
              :class="{
                'bg-white': vegan,
                'border-gray-200': vegan,
                'shadow-sm': vegan,
              }"
              class="transition-colors relative w-1/2 rounded-md py-2 text-sm font-medium text-gray-700 whitespace-nowrap focus:outline-none focus:z-10 sm:w-auto sm:px-8"
            >
              Vegan
            </button>
            <button
              type="button"
              @click="vegan = false"
              :class="{
                'bg-white': !vegan,
                'border-gray-200': !vegan,
                'shadow-sm': !vegan,
              }"
              class="transition-colors ml-0.5 relative w-1/2 border border-transparent rounded-md py-2 text-sm font-medium text-gray-700 whitespace-nowrap focus:outline-none focus:z-10 sm:w-auto sm:px-8"
            >
              Standard
            </button>
          </div>
          <div class="">
          <a
            @click="checkout"
            :class="{'opacity-40': cart.length < 3 || cart.length > 5, 'pointer-events-none': cart.length < 3 || cart.length > 5}"
            class="cursor-pointer mt-8 flex text-lg self-start max-w-max pr-4 text-white pl-9 items-center w-full bg-orange hover:bg-orange-400 rounded-md py-2 font-semibold text-center"
          >
            <svg
              class="absolute -ml-7 mr-3 h-5 w-5"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
              fill="currentColor"
              aria-hidden="true"
            >
              <path
                fill-rule="evenodd"
                d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                clip-rule="evenodd"
              />
            </svg>
            <span v-if="cart.length < 3">wählen Sie mindestens 3 Produkte</span>
            <span v-else-if="cart.length > 5">wählen Sie höchstens 5 Produkte</span>
            <span v-else>Jetzt meine Box sichern</span>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="mx-auto px-4 sm:px-6 lg:px-8">
      <div class="max-w-7xl mx-auto sm:flex sm:flex-col sm:align-center">
        <h3 class="sm:mt-8 mt-4 text-2xl font-extrabold text-gray-900">Bedeutung</h3>
      <div class="flex mt-3 text-center flex-wrap text-xs md:text-sm font-semibold">
        <div class="flex justify-center items-center flex-col mr-4 mb-4">
          <img class="block md:h-16 h-10 mb-2" src="/legende/Icon_Verdauung.png">
          <span class="text-primary-500">Verdauung</span>
        </div>
        <div class="flex justify-center items-center flex-col mr-4 mb-4">
          <img class="block md:h-16 h-10 mb-2" src="/legende/Icon_Stress.png">
          <span class="text-primary-500">Stress</span>
        </div>
        <div class="flex justify-center items-center flex-col mr-4 mb-4">
          <img class="block md:h-16 h-10 mb-2" src="/legende/Icon_Konzentration.png">
          <span class="text-primary-500">Gehirn</span>
        </div>
        <div class="flex justify-center items-center flex-col mr-4 mb-4">
          <img class="block md:h-16 h-10 mb-2" src="/legende/Icon_Knochen & Gelenke.png">
          <span class="text-primary-500">Knochen & Gelenke</span>
        </div>
        <div class="flex justify-center items-center flex-col mr-4 mb-4">
          <img class="block md:h-16 h-10 mb-2" src="/legende/Icon_Immunsystem.png">
          <span class="text-primary-500">Immunsystem</span>
        </div>
        <div class="flex justify-center items-center flex-col mr-4 mb-4">
          <img class="block md:h-16 h-10 mb-2" src="/legende/Icon_Herz.png">
          <span class="text-primary-500">Herz</span>
        </div>
        <div class="flex justify-center items-center flex-col mr-4 mb-4">
          <img class="block md:h-16 h-10 mb-2" src="/legende/Icon_Haut & Anti-Aging.png">
          <span class="text-primary-500">Haut & Anti-Aging</span>
        </div>
        <div class="flex justify-center items-center flex-col mr-4 mb-4">
          <img class="block md:h-16 h-10 mb-2" src="/legende/Icon_Haare & Nägel.png">
          <span class="text-primary-500">Haare & Nägel</span>
        </div>
        <div class="flex justify-center items-center flex-col mr-4 mb-4">
          <img class="block md:h-16 h-10 mb-2" src="/legende/Icon_Fitness & Sport.png">
          <span class="text-primary-500">Bewegung</span>
        </div>
        <div class="flex justify-center items-center flex-col mr-4 mb-4">
          <img class="block md:h-16 h-10 mb-2" src="/legende/Icon_Energie.png">
          <span class="text-primary-500">Energie</span>
        </div>
      </div>
      <h2 class="sm:mt-8 text-3xl font-extrabold text-gray-900">
        Deine {{ yourProducts.slice(0, 3).filter(p => p && p !== '').filter(
            (p) =>
              productData[p] &&
              (productData[p].available || !productData[p].available)
          ).length }} Essentials
      </h2>
      <div
        class="space-y-4 mt-3 sm:mt-4 sm:space-y-0 sm:grid sm:grid-cols-3 sm:gap-6 xl:grid-cols-4"
      >
        <div
          v-for="product in yourProducts.slice(0, 3).filter(p => p && p !== '').filter(
            (p) =>
              productData[p] &&
              (productData[p].available || !productData[p].available)
          )"
          :key="product"
          class=""
        >
          <ProductGridItem
            v-if="productData[product]"
            :productData="productData[product]"
            :meta="meta[product]"
            :added="cart.includes(product)"
            @add="cart.push(product)"
            @remove="cart.splice(cart.indexOf(product), 1)"
            @show-modal="slide = productData[product]"
          />
        </div>
      </div>
      </div>
    </div>
    <div class="mx-auto px-4 sm:px-6 lg:px-8">
      <div class="max-w-7xl mx-auto sm:flex sm:flex-col sm:align-center">
      <h2 class="sm:mt-16 text-3xl font-extrabold text-gray-900">
        Deine {{ yourProducts.slice(3, 5).filter(p => p && p !== '').length }} möglichen Add-ons
      </h2>
      <h3 class="text-2xl" v-if="answers['natureHealth'] == true">da du offen für alternative Naturheilkunde bist</h3>
      <div
        class="space-y-4 mt-3 sm:mt-4 sm:space-y-0 sm:grid sm:grid-cols-3 sm:gap-6 xl:grid-cols-4"
      >
        <div
          v-for="product in yourProducts.slice(3, 5).filter(p => p && p !== '').filter(
            (p) =>
              productData[p] &&
              (productData[p].available || !productData[p].available)
          )"
          :key="product"
          class=""
        >
          <ProductGridItem
            v-if="productData[product]"
            :productData="productData[product]"
            :meta="meta[product]"
            :added="cart.includes(product)"
            @add="cart.push(product)"
            @remove="cart.splice(cart.indexOf(product), 1)"
            @show-modal="slide = productData[product]"
          />
        </div>
      </div>
      </div>
    </div>
    <div class="mx-auto px-4 sm:px-6 lg:px-8">
      <div class="max-w-7xl mx-auto sm:flex sm:flex-col sm:align-center">
      <h2 class="sm:mt-16 text-3xl font-extrabold text-gray-900">
        Weitere Optionen
      </h2>
      <div
        class="space-y-4 mt-3 sm:mt-4 sm:space-y-0 sm:grid sm:grid-cols-3 sm:gap-6 xl:grid-cols-4"
      >
        <div
          v-for="product in Object.keys(skuToHandle).filter(p => p && p !== '' && !yourProducts.includes(p)).filter(
            (p) =>
              productData[p] &&
              (productData[p].available || !productData[p].available)
          ).filter(p => !vegan || productData[p].tags.includes('vegan'))"
          :key="product"
          class=""
        >
          <ProductGridItem
            v-if="productData[product]"
            :productData="productData[product]"
            :meta="meta[product]"
            :added="cart.includes(product)"
            @add="cart.push(product)"
            @remove="cart.splice(cart.indexOf(product), 1)"
            @show-modal="slide = productData[product]"
          />
        </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import skuToHandle from "./../assets/skuToHandle";
import sets from "./../assets/sets_non_vegan";
import setsVegan from "./../assets/sets_vegan";
import ProductGridItem from "./ProductGridItem";
import ProductSlideover from "./ProductSlideover";

export default {
  name: "Products",
  components: {
    ProductGridItem,
    ProductSlideover
  },
  props: {
    answers: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      slide: null,
      gewichtung: {
        "gf-multiv-450": 5,
        "gf-vitaminc": 4,
        "gf-zink": 4,
        "gf-opc-intensiv-60-v.0": 2,
        "gf-dktabletten": 4,
        "gf-maca-200": 5,
        "gf-f-burn": 3,
        "gf-trimagnesium": 5,
        "gf-reishi": 3,
        "gf-sp-arginin": 4,
        "gf-sp-carnitin": 2,
        "gf-sp-bcaa": 3,
        "gf-biotin": 5,
        "gf-hanfsamenöl": 3,
        "gf-hyaluron": 5,
        "gf-curcumin-400": 4,
        "gf-probivia": 5,
        "gf-calcium": 4,
        "gf-msm330": 4,
        "gf-mariendistel": 5,
        "gf-vitaminb-200": 5,
        "gf-omega3": 5,
        "gf-vitaminb12-200": 4,
        "gf-mönchspfeffer": 3,
      },
      console: console,
      recommendations: [
        {
          condition: ["immuneSystem__question-2", "==", true],
          products: [
            "gf-n-multi180",
            "gf-vitaminc",
            "gf-zink",
            "gf-n-zink",
            "gf-n-zinktropfen",
            "gf-opc-intensiv-60-v",
            "gf-n-opc180",
          ],
          reason: "Um deine Abwehrkräfte zu stärken",
        },
        {
          // [['immuneSystem__question-2', '==', true], '&&' ,[['diet', 'notIncludes', 'vegan'], '&&', ['diet', 'notIncludes', 'vegetarian']]]
          condition: [
            ["immuneSystem__question-2", "==", true],
            "&&",
            ["diet", "notIncludes", "vegan"],
          ],
          products: ["gf-dktabletten", "gf-n-dktropfen", "gf-multiv-450"],
          reason: "Um deine Abwehrkräfte zu stärken",
        },
        {
          condition: ["immuneSystem__question-1", "==", true],
          products: [
            "gf-n-multi180",
            "gf-vitaminc",
            "gf-zink",
            "gf-n-zink",
            "gf-n-zinktropfen",
            "gf-opc-intensiv-60-v",
            "gf-n-opc180",
          ],
          reason: "Damit du nicht mehr angeschlagen und schlapp bist",
        },
        {
          condition: [
            ["immuneSystem__question-1", "==", true],
            "&&",
            ["diet", "notIncludes", "vegan"],
          ],
          products: ["gf-dktabletten", "gf-n-dktropfen", "gf-multiv-450"],
          reason: "Damit du nicht mehr angeschlagen und schlapp bist",
        },
        {
          condition: ["immuneSystem__question-3", "==", true],
          products: [
            "gf-n-multi180",
            "gf-vitaminc",
            "gf-zink",
            "gf-n-zink",
            "gf-n-zinktropfen",
            "gf-opc-intensiv-60-v",
            "gf-n-opc180",
          ],
          reason: "Damit du täglich an öffentlichen Orten geschüzt bist",
        },
        {
          condition: [
            ["immuneSystem__question-3", "==", true],
            "&&",
            ["diet", "notIncludes", "vegan"],
          ],
          products: ["gf-dktabletten", "gf-n-dktropfen", "gf-multiv-450"],
          reason: "Damit du täglich an öffentlichen Orten geschüzt bist",
        },
        {
          condition: ["energy__question-1", "==", true],
          products: ["gf-maca-200"],
          reason: "Damit du nicht mehr kraftlos und erschöpft bist",
        },
        {
          condition: ["energy__question-2", "==", true],
          products: ["gf-maca-200"],
          reason: "Damit du morgens besser aufstehen kannst",
        },
        {
          condition: ["energy__question-3", "==", true],
          products: ["gf-maca-200"],
          reason: "Damit du deine herausfordernde Situation meisterst",
        },
        {
          condition: ["sleep__question-1", "==", true],
          products: ["gf-trimagnesium", "gf-n-magnesium"],
          reason:
            "Damit du besser einzuschlafen und nachts durchzuschlafen kannst",
        },
        {
          condition: ["sleep__question-3", "==", true],
          products: ["gf-trimagnesium", "gf-n-magnesium"],
          reason:
            "Damit du auch mit weniger als 7 Stunden Schlaf pro Nacht fit bist",
        },
        {
          condition: ["stress__question-2", "==", true],
          products: ["gf-reishi"],
          reason: "Damit du den stressigen Alltag meisterst",
        },
        {
          condition: ["stress__question-1", "==", true],
          products: ["gf-reishi"],
          reason: "Damit du dich nicht mehr überfordert fühlst",
        },
        {
          condition: ["stress__question-3", "==", "permanentStress"],
          products: ["gf-reishi"],
          reason: "Damit dein Stresspegel sinkt",
        },
        {
          condition: ["sport__question-1", "==", true],
          products: [
            "gf-sp-carnitin",
            "gf-trimagnesium",
            "gf-n-magnesium",
            "gf-zink",
            "gf-n-zink",
            "gf-n-zinktropfen",
          ],
          reason: "Damit du dich allgemein fitter fühlst",
        },
        {
          condition: [
            ["sport__question-1", "==", true],
            "&&",
            [
              ["diet", "notIncludes", "vegan"],
              "&&",
              ["diet", "notIncludes", "vegetarian"],
            ],
          ],
          products: ["gf-sp-bcaa", "gf-sp-arginin"],
          reason: "Damit du dich allgemein fitter fühlst",
        },
        /*{
                  condition: ['sport__question-2', '==', true],
                  products: ['gf-sp-carnitin', 'gf-f-burn','gf-trimagnesium','gf-n-magnesium','gf-zink','gf-n-zink','gf-n-zinktropfen'],
                  reason: 'Damit du deine sportliche Leistungsfähigkeit steigern kannst'
              },
              {
                  condition: [['sport__question-2', '==', true], '&&' ,[['diet', 'notIncludes', 'vegan'], '&&', ['diet', 'notIncludes', 'vegetarian']]],
                  products: ['gf-sp-bcaa', 'gf-sp-arginin'],
                  reason: 'Damit du deine sportliche Leistungsfähigkeit steigern kannst'
              },*/
        {
          condition: ["hairAndNails__question-1", "==", true],
          products: [
            "gf-biotin",
            "gf-eisen",
            "gf-opc-intensiv-60-v.0",
            "gf-n-opc180",
            "gf-zink",
            "gf-n-zink",
            "gf-n-zinktropfen",
          ],
          reason: "Damit du keine brüchigen oder eingerissenen Nägel bekommst",
        },
        {
          condition: [
            ["hairAndNails__question-1", "==", true],
            "&&",
            [
              ["diet", "notIncludes", "vegan"],
              "&&",
              ["diet", "notIncludes", "vegetarian"],
            ],
          ],
          products: ["gf-hanfsamenöl"],
          reason: "Damit du keine brüchigen oder eingerissenen Nägel bekommst",
        },
        {
          condition: ["hairAndNails__question2", "==", true],
          products: [
            "gf-biotin",
            "gf-eisen",
            "gf-opc-intensiv-60-v.0",
            "gf-n-opc180",
            "gf-zink",
            "gf-n-zink",
            "gf-n-zinktropfen",
          ],
          reason: "Damit du mehr Fülle und kraftvolleres Haar bekommst",
        } /*
              {
                  condition: [['hairAndNails__question-2', '==', true], '&&' ,[['diet', 'notIncludes', 'vegan'], '&&', ['diet', 'notIncludes', 'vegetarian']]],
                  products: ['gf-hanfsamenöl'],
                  reason: 'Damit du mehr Fülle und kraftvolleres Haar bekommst'
              },*/,
        {
          condition: ["skin__question-1", "==", true],
          products: [
            "gf-hyaluron",
            "gf-hyaluron-serum-50",
            "gf-vit-c-serum",
            "gf-retinol-serum",
            "gf-opc-intensiv-60-v.0",
            "gf-n-opc180",
            "gf-curcumin-400",
            "gf-nbio-curcuma",
          ],
          reason: "Damit du dein Hautbild verbesserst",
        },
        {
          condition: ["skin__question-3", "==", true],
          products: [
            "gf-hyaluron",
            "gf-hyaluron-serum-50",
            "gf-vit-c-serum",
            "gf-retinol-serum",
            "gf-opc-intensiv-60-v.0",
            "gf-n-opc180",
            "gf-curcumin-400",
            "gf-nbio-curcuma",
          ],
          reason: "Gegen unreine Haut oder Akne",
        } /*
              {
                  condition: ['digestion__question-2', '==', true],
                  products: ['gf-probivia','gf-bio-probivia'],
                  reason: 'Damit du deine Verdauung auf natürliche Weise verbesserst'
              }, */,
        {
          condition: [
            ["bones__question-1", "==", true],
            "&&",
            ["diet", "notIncludes", "vegan"],
          ],
          products: ["gf-calcium"],
          reason: "Gegen Gelenkbeschwerden",
        },
        {
          condition: [
            ["bones__question-1", "==", true],
            "&&",
            [
              ["diet", "notIncludes", "vegan"],
              "&&",
              ["diet", "notIncludes", "vegetarian"],
            ],
          ],
          products: ["gf-schwarzkümmelöl"],
          reason: "Gegen Gelenkbeschwerden",
        },
        {
          condition: ["bones__question-1", "==", true],
          products: [
            "gf-msm330",
            "gf-msmtablette",
            "gf-curcumin-400",
            "gf-nbio-curcuma",
          ],
          reason: "Gegen Gelenkbeschwerden",
        } /*
              {
                  condition: [['bones__question-2', '==', true], '&&' ,['diet', 'notIncludes', 'vegan']],
                  products: ['gf-calcium'],
                  reason: 'Für mehr Beweglichkeit deiner Gelenke'
              },
              {
                  condition: [['bones__question-2', '==', true], '&&' ,[['diet', 'notIncludes', 'vegan'], '&&', ['diet', 'notIncludes', 'vegetarian']]],
                  products: ['gf-schwarzkümmelöl'],
                  reason: 'Für mehr Beweglichkeit deiner Gelenke'
              },
              {
                  condition: ['bones__question-2', '==', true],
                  products: ['gf-msm330','gf-msmtablette','gf-curcumin-400','gf-nbio-curcuma'],
                  reason: 'Für mehr Beweglichkeit deiner Gelenke'
              }, */,
        {
          condition: ["detox__question-2", "==", true],
          products: ["gf-mariendistel", "gf-curcumin-400", "gf-nbio-curcuma"],
          reason:
            "Damit du deinen Körper aktiv bei der Reinigung unterstützen kannst",
        },
        {
          condition: ["detox__question-1", "==", true],
          products: ["gf-mariendistel", "gf-curcumin-400", "gf-nbio-curcuma"],
          reason: "Damit du dich nicht mehr träge, müde und ausgelaugt bist",
        } /*
              {
                  condition: ['concentration__question-2', '==', true],
                  products: ['gf-vitaminb-200','gf-n-bkomplex'],
                  reason: 'Damit du dein Erinnerungsvermögen verbessern kannst'
              }, 
              {
                  condition: ['metabolism__question-1', '==', true],
                  products: ['gf-f-burn'],
                  reason: 'Damit du weniger kleine Zwischenmahlzeiten und Snacks essen musst'
              }, 
              {
                  condition: ['metabolism__question-2', '==', true],
                  products: ['gf-f-burn'],
                  reason: 'Damit du deinen Stoffwechsel auf natürliche Weise anregst'
              },
              */,

        {
          condition: [["fields", "==", "immuneSystem"], "&&"],
          products: ["gf-dktabletten", "gf-n-dktropfen", "gf-multiv-450"],
          reason: "Für dein Immunsystem",
        },
        {
          condition: ["fruitConsumption", "==", "never"],
          products: ["gf-multiv-450", "gf-n-multi180"],
          reason: "Da du selten Obst zu dir nehmen zu scheinst.",
        },
        {
          condition: ["meatConsumption", "==", "never"],
          products: ["gf-omega3", "gf-n-omega3"],
          reason: "Da du selten Fleisch zu dir nehmen zu scheinst.",
        },
        {
          condition: ["fishConsumption", "includes", "never"],
          products: ["gf-omega3", "gf-n-omega3"],
          reason: "Um deinen Omega3 Gehalt auszugleichen",
        },
        {
          condition: ["diet", "includes", "vegan"],
          products: ["gf-vitaminb12-200"],
          reason: "Um deine vegane Ernährung zu unterstützen",
        },
        {
          condition: ["diet", "includes", "vegetarian"],
          products: ["gf-vitaminb12-200"],
          reason: "Um deine vegetarische Ernährung zu unterstützen",
        },
        {
          condition: ["diet", "includes", "vegetarian"],
          products: ["gf-vitaminb12-200", "gf-n-b12", "gf-n-b12tropfen"],
          reason: "Um deine vegetarische Ernährung zu ergänzen.",
        },
        {
          condition: ["oftenAlcohol", "==", true],
          products: ["gf-trimagnesium", "gf-n-magnesium", "gf-mariendistel"],
          reason: "Da du häufiger Alkohol zu trinken scheinst.",
        },
        {
          condition: ["sportType", "includes", "strength"],
          products: ["gf-sp-carnitin", "gf-trimagnesium", "gf-n-magnesium"],
          reason: "Um dich beim Krafttraining zu unterstützen.",
        },
        {
          condition: [
            ["sportType", "includes", "strength"],
            "&&",
            [
              ["diet", "notIncludes", "vegan"],
              "&&",
              ["diet", "notIncludes", "vegetarian"],
            ],
          ],
          products: ["gf-sp-bcaa", "gf-sp-arginin"],
          reason: "Um dich beim Krafttraining zu unterstützen",
        },
        {
          condition: ["sportType", "includes", "stamina"],
          products: [
            "gf-trimagnesium",
            "gf-n-magnesium",
            "gf-zink",
            "gf-n-zink",
            "gf-n-zinktropfen",
          ],
          reason: "Um dich beim Ausdauertraing zu unterstützen.",
        },
        {
          condition: [
            ["sportType", "includes", "strength"],
            "&&",
            [
              ["diet", "notIncludes", "vegan"],
              "&&",
              ["diet", "notIncludes", "vegetarian"],
            ],
          ],
          products: ["gf-sp-bcaa"],
          reason: "Um dich beim Ausdauertraing zu unterstützen.",
        },
        {
          condition: ["sportType", "includes", "relaxation"],
          products: [
            "gf-trimagnesium",
            "gf-n-magnesium",
            "gf-zink",
            "gf-n-zink",
            "gf-n-zinktropfen",
          ],
          reason: "Um dich beim Entspannungssport zu unterstützen.",
        },
        {
          condition: ["sportType", "includes", "other"],
          products: ["gf-trimagnesium", "gf-n-magnesium"],
          reason: "Zur Unterstützung deiner sportlichen Aktivität.",
        },
        {
          condition: ["sportGoal", "includes", "stamina"],
          products: ["gf-sp-carnitin", "gf-trimagnesium", "gf-n-magnesium"],
          reason: "Um dein Ausdauerleistungsziel zu erreichen.",
        },
        {
          condition: ["sportGoal", "includes", "muscleStrength"],
          products: ["gf-sp-carnitin", "gf-trimagnesium", "gf-n-magnesium"],
          reason: "Um deinen Muskelaufbau zu begleiten.",
        },
        {
          condition: [
            ["sportGoal", "includes", "muscleStrength"],
            "&&",
            [
              ["diet", "notIncludes", "vegan"],
              "&&",
              ["diet", "notIncludes", "vegetarian"],
            ],
          ],
          products: ["gf-sp-bcaa", "gf-sp-arginin"],
          reason: "Um deinen Muskelaufbau zu begleiten",
        },
        {
          condition: ["sportGoal", "includes", "weightLoss"],
          products: ["gf-sp-carnitin"],
          reason: "Um deine Gewichtsabnahme zu begleiten.",
        },
        {
          condition: ["sportGoal", "includes", "generalHealth"],
          products: ["gf-trimagnesium", "gf-n-magnesium"],
          reason: "Zur gesunden Lebensweise.",
        },
        {
          condition: ["sportSupport", "includes", "muscleRelaxation"],
          products: ["gf-sp-carnitin", "gf-trimagnesium", "gf-n-magnesium"],
          reason: "Um die Muskelerholung zu begleiten.",
        },
        {
          condition: [
            ["sportSupport", "includes", "muscleRelaxation"],
            "&&",
            [
              ["diet", "notIncludes", "vegan"],
              "&&",
              ["diet", "notIncludes", "vegetarian"],
            ],
          ],
          products: ["gf-sp-bcaa", "gf-sp-arginin"],
          reason: "Um die Muskelerholung zu begleiten.",
        },
        {
          condition: ["sportSupport", "includes", "muscleSpasms"],
          products: ["gf-trimagnesium", "gf-n-magnesium"],
          reason: "Um Muskelkrämpfen entgegenzuwirken.",
        },
        {
          condition: ["oftenTired", "includes", true],
          products: ["gf-trimagnesium", "gf-n-magnesium"],
          reason: "Da du häufig müde scheinst.",
        },
        {
          condition: ["oftenIndoors", "includes", true],
          products: ["gf-dktabletten", "gf-n-dktropfen"],
          reason: "Da du dich scheinbar oft in geschlossenen Räumen aufhälst.",
        },
        {
          condition: [
            ["oftenIndoors", "includes", true],
            "&&",
            ["diet", "notIncludes", "vegan"],
          ],
          products: ["gf-dktabletten", "gf-n-dktropfen"],
          reason: "Da du dich scheinbar oft in geschlossenen Räumen aufhälst",
        },
      ],
      productData: {},
      meta: {},
      cart: [],
      skuToHandle: skuToHandle
    };
  },
  created() {

    setTimeout(() => {
      const productString = this.cart.map(sku => `${this.meta[sku].variantId}:1`).join(',')  
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', {
        '$email': this.answers.email,
        'yg20_checkoutUrl': `https://www.gloryfeel.de/cart/${productString}`
      }]);
      window._learnq.push(['track', 'yg20Finished', {}]);
    }, 5000)

  },
  computed: {
    vegan: {
      get() {
        return (this.answers.diet || []).includes("vegan");
      },
      set(val) {
        if (val) {
          this.answers.diet = this.answers.diet || [];
          this.answers.diet.push("vegan");
        } else {
          this.answers.diet = this.answers.diet.filter((s) => s !== "vegan");
        }
      },
    },
    yourProducts() {
      if ((this.answers.diet || []).includes("vegan")) {
        return setsVegan[this.answers["fields"][0]][this.answers["fields"][1]]
      }
      return sets[this.answers["fields"][0]][this.answers["fields"][1]]
    }
  },
  watch: {
    yourProducts: {
      deep: true,
      immediate: true,
      handler() {
        console.log("go");
        console.log(this.yourProducts);
        this.cart = []
        this.cart.push(...this.yourProducts.slice(0,3).filter(d => d && d !== ''))
        let skus = Object.keys(this.skuToHandle)
          .map((p) => p)
          .filter((s) => typeof s != "undefined")
          .filter((s) => typeof skuToHandle[s] != "undefined");
        console.log(skus);
        let req = skus.map((sku) => {
          console.log(
            sku,
            skuToHandle[sku],
            `https://www.gloryfeel.de/products/${skuToHandle[sku]}.js`
          );
          return new Promise((res) => {
            try {
              axios
                .get(`https://www.gloryfeel.de/products/${skuToHandle[sku]}.js`)
                .then(res)
                .catch(() => res({ data: { available: false } }));
            } catch (err) {
              res({ data: { available: false } });
            }
          });
        });

        let req2 = skus.map((sku) => {
          console.log(
            sku,
            skuToHandle[sku],
            `https://www.gloryfeel.de/products/${skuToHandle[sku]}?view=ajaxrequest`
          );
          return new Promise((res) => {
            try {
              axios
                .get(`https://www.gloryfeel.de/products/${skuToHandle[sku]}?view=ajaxrequest`)
                .then(res)
                .catch(() => res({ data: { available: false } }));
            } catch (err) {
              res({ data: { available: false } });
            }
          });
        });

        Promise.all(req)
          .then((results) => {
            for (let i = 0; results.length > i; i++) {
              this.$set(this.productData, skus[i], results[i].data);
            }
          })
          .catch(console.log);
          Promise.all(req2)
          .then((results) => {
            for (let i = 0; results.length > i; i++) {
              this.$set(this.meta, skus[i], results[i].data);
            }
          })
          .catch(console.log);
      },
    },
  },
  methods: {
    checkout() {
      const productString = this.cart.map(sku => `${this.meta[sku].variantId}:1`).join(',')  
      window.location.href = `https://www.gloryfeel.de/cart/${productString}`
    },
    add2cart(id) {
      window.parent.postMessage({ variantId: id }, "https://gloryfeel.de");
      window.parent.postMessage({ variantId: id }, "https://www.gloryfeel.de");
    },
    evalCondition(condition) {
      global.pr = this;
      if (condition && Array.isArray(condition) && condition.length == 3) {
        let [key, operator, val] = condition;
        const keyOrVal = (key) => {
          if (typeof key == "string") {
            return this.answers[key];
          } else {
            return key;
          }
        };
        switch (operator) {
          case "==":
            return keyOrVal(key) == val;
          case ">":
            return keyOrVal(key) > val;
          case "<":
            return keyOrVal(key) < val;
          case ">=":
            return keyOrVal(key) >= val;
          case "<=":
            return keyOrVal(key) <= val;
          case "&&":
            return this.evalCondition(key) && this.evalCondition(val);
          case "||":
            return this.evalCondition(key) || this.evalCondition(val);
          case "includes":
            return (
              Array.isArray(this.answers[key]) &&
              this.answers[key].includes(val)
            );
          case "includedIn":
            return Array.isArray(val) && val.includes(this.answers[key]);
          case "notIncludes":
            return (
              Array.isArray(this.answers[key]) &&
              !this.answers[key].includes(val)
            );
          case "notIncludedIn":
            return Array.isArray(val) && !val.includes(this.answers[key]);
          default:
            return true;
        }
      } else if (condition == false) {
        return false;
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
.product {
  margin: 16px;
  width: 100%;
  max-width: 380px;
  border: 1px solid #909090;
  color: #002c4d;
  border-radius: 12px;
}

.product-question {
  font-size: 1.1em;
  font-weight: bold;
  color: #3b5881;
  margin-top: 16px;
  display: block;
}

.product-cta {
  display: inline-block;
  color: #fff;
  background: #e4b023;
  padding: 12px 16px;
  width: calc(100% - 64px);
  text-decoration: none;
  font-weight: bold;
  letter-spacing: 0.7px;
  font-size: 1.3em;
  margin: 6px auto 18px auto;
  cursor: pointer;
}

.product-cta.faded {
  background: #757574;
}

.product ul {
  text-align: left;
  font-weight: bold;
  font-size: 1.2em;
}

.product h3 {
  color: #002c4d;
  font-size: 1.8em;
}

.product-img {
  display: block;
  margin: auto;
  padding: 16px 0;
  width: 75%;
}

.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
}

.absoulute-fixer {
  position: absolute;
  top: calc(50vh - 117px);
  transform: translateY(-50%);
  left: 0;
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: all 1s ease;
}

.fade-enter-active {
  transition-delay: 1s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(60px);
}

.wrapper {
  margin: auto;
  position: relative;
}

.bottom-nav {
  bottom: 0;
  left: 0;
  width: 100%;
  margin: 32px 0;
  display: flex;
  justify-content: center;
}

.bottom-nav button {
  background: transparent;
  border: 2px solid #002c4d;
  color: #002c4d;
  font-weight: bold;
  padding: 8px 16px;
  margin: 8px;
  display: block;
  cursor: pointer;
  font-size: 1.3em;
  border-radius: 0px;
}

.bottom-nav button.next {
  background: #e4b023;
  color: #fff;
  border-color: #e4b023;
}

.bottom-nav button.prev {
  color: #e4b023;
  border-color: #e4b023;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
}

.slide-enter-active {
  transition-delay: 0.5s;
}

.slide-enter, .slide-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(100%);
}
</style>
